// data.js

export const patientRows = [
  ['James Hunt', '03/06/2006 (20 yrs)', '21040897'],
  ['Philip. Cammee John', '03/06/2006 (20 yrs)', '21040898'],
  ['Alice Johnson', '08/12/1998 (28 yrs)', '21040899'],
  ['William Brown', '11/03/1985 (41 yrs)', '21040900'],
  ['Emma Wilson', '19/07/1992 (34 yrs)', '21040901'],
  ['Sophia Davis', '21/01/1995 (31 yrs)', '21040902'],
  ['Liam Miller', '30/10/1988 (37 yrs)', '21040903'],
  ['Olivia Moore', '15/02/1997 (29 yrs)', '21040904'],
  ['Noah Taylor', '09/09/1991 (35 yrs)', '21040905'],
  ['Ava Anderson', '17/04/1996 (30 yrs)', '21040906'],
  ['Ethan Thomas', '24/08/1990 (36 yrs)', '21040907'],
  ['Mia Jackson', '13/11/1994 (32 yrs)', '21040908'],
  ['Lucas White', '04/05/1989 (38 yrs)', '21040909'],
  ['Charlotte Harris', '18/06/1993 (33 yrs)', '21040910'],
  ['Benjamin Martin', '07/01/1987 (39 yrs)', '21040911'],
  ['Amelia Thompson', '29/09/1998 (28 yrs)', '21040912'],
  ['Henry Garcia', '14/12/1992 (34 yrs)', '21040913'],
  ['Harper Martinez', '02/02/1999 (27 yrs)', '21040914'],
  ['Daniel Robinson', '10/10/1986 (40 yrs)', '21040915'],
  ['Ella Clark', '26/07/1995 (31 yrs)', '21040916'],
  ['Michael Rodriguez', '05/03/1991 (35 yrs)', '21040917'],
  ['Grace Lewis', '12/05/1997 (29 yrs)', '21040918'],
  ['David Lee', '22/08/1984 (42 yrs)', '21040919'],
  ['Chloe Walker', '09/01/1996 (30 yrs)', '21040920'],
  ['Matthew Hall', '27/11/1988 (37 yrs)', '21040921'],
  ['Lily Allen', '16/04/1994 (32 yrs)', '21040922'],
  ['Joseph Young', '03/09/1993 (33 yrs)', '21040923'],
  ['Zoe Hernandez', '08/06/1998 (28 yrs)', '21040924'],
  ['Samuel King', '19/12/1987 (39 yrs)', '21040925'],
  ['Victoria Wright', '01/07/1995 (31 yrs)', '21040926'],
  ['Christopher Lopez', '23/02/1990 (36 yrs)', '21040927'],
  ['Natalie Hill', '11/10/1997 (29 yrs)', '21040928'],
  ['Andrew Scott', '20/05/1985 (41 yrs)', '21040929'],
  ['Hannah Green', '14/08/1996 (30 yrs)', '21040930'],
  ['Joshua Adams', '28/03/1992 (34 yrs)', '21040931'],
  ['Aria Baker', '06/11/1999 (27 yrs)', '21040932'],
  ['Ryan Nelson', '17/01/1989 (38 yrs)', '21040933'],
  ['Scarlett Carter', '30/09/1994 (32 yrs)', '21040934'],
  ['Nathan Mitchell', '25/04/1991 (35 yrs)', '21040935'],
  ['Emily Perez', '12/06/1998 (28 yrs)', '21040936']
];

export const columns = [
  {
    field: 'pname',
    headerName: 'Patient Name',
    width: '38%',
    primary: true,
    skeletonWidth: '60%'
  },
  {
    field: 'dob',
    headerName: 'Date of Birth',
    width: '32%',
    skeletonWidth: '45%'
  },
  {
    field: 'mr',
    headerName: 'MR#',
    width: '22%',
    skeletonWidth: '40%'
  }
];